/** Statsig gate for the Product Release (temperature release) list alignment with the CC V3 list. */
export const PRODUCT_RELEASE_V1_GATE = 'product-release-v1'

/**
 * @param {object | null | undefined} statsigClient - Statsig client from `useStatsigClient()`.
 * @returns {boolean} Whether the Product Release surfaces run the V3 list layout.
 */
export const isProductReleaseV1Enabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(PRODUCT_RELEASE_V1_GATE))

/** Statsig gate for Product Release v1.1 (shipment cancel via `cancel_shipment_v1`). */
export const PRODUCT_RELEASE_V1_1_GATE = 'product-release-v1.1'

/**
 * @param {object | null | undefined} statsigClient - Statsig client from `useStatsigClient()`.
 * @returns {boolean} Whether Product Release v1.1 behaviour is enabled.
 */
export const isProductReleaseV1_1Enabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(PRODUCT_RELEASE_V1_1_GATE))

export const PRODUCT_RELEASE_V1_2_GATE = 'product-release-v1.2'
export const isProductReleaseV1_2Enabled = (statsigClient) =>
  Boolean(statsigClient?.checkGate?.(PRODUCT_RELEASE_V1_2_GATE))
